import { type HttpClientConfig, type HttpClientInterface } from 'core/infra/http/HttpClient'

export type RefreshInviteTokenParams = {
  carrierInviteLinkUuid: string
}

export function mapApiToEmailRecipient({ email_recipient }: { email_recipient?: string }) {
  return email_recipient || undefined
}

type InviteTokenRepositoryDependencies = {
  httpClient: HttpClientInterface
}

export class InviteTokenRepository {
  private readonly httpClient: HttpClientInterface

  constructor({ httpClient }: InviteTokenRepositoryDependencies) {
    this.httpClient = httpClient
  }

  async refreshToken(
    { carrierInviteLinkUuid }: RefreshInviteTokenParams,
    config?: Partial<HttpClientConfig>
  ): Promise<string | undefined> {
    const payload = { carrier_invite_link_uuid: carrierInviteLinkUuid }

    const response = await this.httpClient.post<{ email_recipient?: string }>(
      'carriers/token/refresh',
      payload,
      config
    )

    return mapApiToEmailRecipient(response.data)
  }
}
